module.exports = __webpack_public_path__ + "static/media/bg_trial_resumption_over_50.72f6e55c.webp";